import React from 'react';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import { ratingToStarDisplay } from '../utils/ratingUtils';

/**
 * Renders 5 stars from a 1–10 rating (e.g. 7.6 → 3½ stars).
 */
function RatingStars({ rating, size = 14, className = '' }) {
  const { full, half } = ratingToStarDisplay(rating);
  const stars = [];

  for (let i = 0; i < 5; i += 1) {
    if (i < full) {
      stars.push(<FaStar key={i} className="text-warning" size={size} />);
    } else if (i === full && half) {
      stars.push(<FaStarHalfAlt key={i} className="text-warning" size={size} />);
    } else {
      stars.push(<FaRegStar key={i} className="text-muted" size={size} />);
    }
  }

  const label =
    rating != null && !Number.isNaN(Number(rating))
      ? `${Number(rating).toFixed(1)} / 10`
      : '';

  return (
    <span
      className={`rating-stars d-inline-flex align-items-center gap-0 ${className}`.trim()}
      role="img"
      aria-label={label}
    >
      {stars}
    </span>
  );
}

export default RatingStars;
